import analyticImg from "../../Images/method-development.jpg";
export function Analytical() {
  return (
    <section className="about-wrap-layout1">
      <div className="container">
        <div className="row">
          <div className="about-box-layout1 order-xl-8 col-xl-8 col-12">
            <div className="item-content">
              <h2 className="item-title"> Analytical development </h2>
              <p>
                The development and validation of analytical methods play
                crucial roles in the discovery, development, and manufacturing
                of pharmaceuticals. Method development is the process of
                demonstrating that an analytical method is suitable for
                measuring the concentration of an Active Pharmaceutical
                Ingredient (API) in a specific compounded dosage form. This
                allows for simplified procedures to be used, ensuring that an
                analytical method can accurately and consistently provide a
                reliable measurement of an active ingredient in a compounded
                preparation. Analytical method validation is a critical step in
                analytical method development. It involves thorough testing for
                specificity, linearity, accuracy, precision, range, detection
                limit, quantization limit, and robustness. In summary,
                analytical method development and validation are essential
                processes that confirm the accurate and reliable measurement of
                the potency of a pharmaceutical preparation can be achieved.
              </p>
              <p>
                all phases of pharmaceutical development in alignment with
                client-specific protocols, internal Standard Operating
                Procedures (SOPs), and guidelines set forth by the FDA and the
                ICH.
              </p>
              <h4> 1. Analytical method development and validation for </h4>
              <div className="about-box-layout5 order-xl-12 col-xl-12 col-12">
                <div className="item-content">
                  <ul className="about-info">
                    <li className="col-12"> Impurity detection </li>
                    <li className="col-12"> Genotoxic impurity detection </li>
                    <li className="col-12"> Elemental impurity by ICP-MS </li>
                    <li className="col-12"> Assay </li>
                  </ul>
                </div>
              </div>
              <h4>
                {" "}
                2. Stability study for Drug products and Drug substances as per
                ICH guidelines.{" "}
              </h4>
              <h4> 3. Microbial testing </h4>
              <div className="about-box-layout5 order-xl-12 col-xl-12 col-12">
                <div className="item-content">
                  <ul className="about-info">
                    <li className="col-12"> Sterility testing </li>
                    <li className="col-12">
                      {" "}
                      Particulate matter test by LPC (Liquid Particle Count){" "}
                    </li>
                    <li className="col-12"> BET </li>
                    <li className="col-12"> MLT testing </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div
            className="about-box-layout2 order-xl-1 col-xl-4 col-lg-4 col-12"
            style={{ marginBottom: "20px" }}
          >
            <div className="item-im">
              <img src={analyticImg} alt="about" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
